import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { router } from "./routes/router";
import { ThemeProvider } from "@mui/material/styles";
import baseTheme from "./assets/styles/theme/baseTheme";
import CssBaseline from "@mui/material/CssBaseline";
import { RecoilRoot } from "recoil";
import "./locales";  /// 다국어 i18n 적용


const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();
root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={baseTheme}>
          <CssBaseline />
          <RecoilRoot>
            <RouterProvider router={router} />
          </RecoilRoot>
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        </ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>,
);

reportWebVitals();
